
















































































import PageHeader from '@/components/PageHeader.vue'
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {PC} from '@/icons'

import {certGuideProcess} from './constants/certGuideProcess'
import Timer from './setting/TimerComponent.vue'

const certificates = namespace('certificates')
const userAgent = namespace('userAgent')

@Component({
  components: {PageHeader, Timer, PC}
})
export default class RegisterCertGuidePopupB extends Vue {
  @certificates.Action('getRegisterCode') getRegisterCode

  @Prop({default: false}) open: boolean

  @userAgent.Getter('isMobile') isMobile: boolean

  certGuideProcess = certGuideProcess
  loading: boolean = true
  code: string = '-----'
  errorMsg: string = ''
  isSharing: boolean = false

  @Watch('open', {immediate: true})
  __open(value) {
    if(value) {
      this.requestCode()
    } else {
      this.initCode()
    }
  }

  initCode() {
    this.code = '-----'
    this.errorMsg = ''
  }

  getTargetUrl() {
    const targetUrl = process.env.NODE_ENV !== 'production' ? 'https://sole-app.stag-a.overtax.co.kr' : 'https://app.sole.overtax.co.kr'
    return `${targetUrl}/cert-corp?auth_code=${this.code}`
  }

  requestCode() {
    this.getRegisterCode({services: []})
      .then((data) => {
        this.loading = false
        this.code = data
        this.errorMsg = ''
        if(!this.isMobile) {
          const targetUrl = this.getTargetUrl()
          window.open(targetUrl, '_blank')
        }
      })
      .catch(() => {
        this.errorMsg = '발급 실패'
      })
  }

  handleTimeUp() {
    this.errorMsg = '유효시간 초과'
  }

  async handleShare() {
    if(this.isSharing) {
      return
    }
    const nav: any = window.navigator
    const targetUrl = this.getTargetUrl()
    const shareData = {
      title: '더낸세금 공동인증센터',
      url: targetUrl,
    }
    
    if(!nav.canShare) {
      this.$emit('help')
      return
    }

    this.isSharing = true
    try {
      await nav.share(shareData)
    } catch(error) {
      if((error as Error).name !== 'AbortError') {
        this.$sentry.captureException(error)
      }
    } finally {
      this.isSharing = false
    }
  }
}
